// src/modules/smelter/routes.jsx
import { Routes, Route } from 'react-router-dom';
import SmelterDirectory from './pages/SmelterDirectory';
import DispatchList from './pages/DispatchList';
import CreateDispatch from './pages/CreateDispatch';
import DispatchDetails from './pages/DispatchDetails';
import SmelterPerformance from './pages/SmelterPerformance';
import GenerateFlyInvoice from './pages/GenerateFlyInvoice';
import SmelterGstLedger from './pages/SmelterGstLedger';
import TransitMemoList from './pages/TransitMemoList';

function SmelterRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SmelterDirectory />} />
      <Route path="/performance" element={<SmelterPerformance />} />
      <Route path="/dispatches" element={<DispatchList />} />
      <Route path="/dispatches/create" element={<CreateDispatch />} />
      <Route path="/dispatches/:id" element={<DispatchDetails />} />
      <Route path="/fly-invoice" element={<GenerateFlyInvoice />} />
      <Route path="/gst-ledger" element={<SmelterGstLedger />} />
      <Route path="/transit-memos" element={<TransitMemoList />} />
    </Routes>
  );
}

export default SmelterRoutes;
